import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useAuth} from "../../sdk";
const EMPTY_ROW = {
  occupancyMin: 0,
  occupancyMax: 100,
  basePriceMW: null,
  basePriceWE: null,
};

export function useSeasonPricing(
  copyFromHotelId,
  HighPrices,
  LowPrices,
  ExtremelyHighPrices,
  MediumPrices,
  openSelectbar
) {
  const [ehsPrices, setEHSPrices] = useState([]);
  const [msPrices, setMSPrices] = useState([]);
  const [lsPrices, setLSPrices] = useState([]);
  const [hsPrices, setHSPrices] = useState([]);
  const [isEHSInEditMode, setIsEHSInEditMode] = useState(false);
  const [isMSInEditMode, setIsMSInEditMode] = useState(false);
  const [isLSInEditMode, setIsLSInEditMode] = useState(false);
  const [isHSInEditMode, setIsHSInEditMode] = useState(false);
  const [isEHSCancelled, setIsEHSCancelled] = useState(false);
  const [isMSCancelled, setIsMSCancelled] = useState(false);
  const [isLSCancelled, setIsLSCancelled] = useState(false);
  const [isHSCancelled, setIsHSCancelled] = useState(false);
  const [isEHSSaved, setIsEHSSaved] = useState(false);
  const [isMSSaved, setIsMSSaved] = useState(false);
  const [isLSSaved, setIsLSSaved] = useState(false);
  const [isHSSaved, setIsHSSaved] = useState(false);
  const [ehsLoading, setehsLoading] = useState(false);
  const [msLoading, setmsLoading] = useState(false);
  const [lsLoading, setlsLoading] = useState(false);
  const [hsLoading, sethsLoading] = useState(false);
  const [checkEHSPricesValidation, setEHSPricesValidation] = useState(false);
  const [checkMSPricesValidation, setMSPricesValidation] = useState(false);
  const [checkLSPricesValidation, setLSPricesValidation] = useState(false);
  const [checkHSPricesValidation, setHSPricesValidation] = useState(false);
  const [Error, setError] = useState(false);
  const [open, setOpen] = useState();
  const {hotelId} = useParams();
  const {token, authFetch} = useAuth();
  const [networkMsg, setnetworkMsg] = useState();
  const [errorMsg, setErrorMsg] = useState();

  useEffect(() => {
    if (!token) return;
    refreshEHSPrices();
    refreshHSPrices();
    refreshMSPrices();
    refreshLSPrices();
  }, [token, hotelId]);

  useEffect(() => {
    if (isEHSInEditMode) {
      const allValidEntries = ehsPrices.every(isValid);
      if (allValidEntries) setEHSPricesValidation(false);
      else setEHSPricesValidation(true);
      const lastEntry = ehsPrices.length
        ? ehsPrices[ehsPrices.length - 1]
        : {
            occupancyMax: null,
          };
      if (
        allValidEntries &&
        lastEntry.occupancyMax < 100 &&
        lastEntry.occupancyMax > 0
      ) {
        setEHSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
            occupancyMin: lastEntry.occupancyMax + 1,
          },
        ]);
      } else if (lastEntry.occupancyMax === null) {
        setEHSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
          },
        ]);
      }
    } else if (isEHSSaved) {
      updateEHSPrice();
    } else if (isEHSCancelled) {
      refreshEHSPrices();
    }
  }, [ehsPrices, isEHSInEditMode]);

  useEffect(() => {
    if (isHSInEditMode) {
      const allValidEntries = hsPrices.every(isValid);
      if (allValidEntries) setHSPricesValidation(false);
      else setHSPricesValidation(true);
      const lastEntry = hsPrices.length
        ? hsPrices[hsPrices.length - 1]
        : {
            occupancyMax: null,
          };
      if (
        allValidEntries &&
        lastEntry.occupancyMax < 100 &&
        lastEntry.occupancyMax > 0
      ) {
        setHSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
            occupancyMin: lastEntry.occupancyMax + 1,
          },
        ]);
      } else if (lastEntry.occupancyMax === null) {
        setHSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
          },
        ]);
      }
    } else if (isHSSaved) {
      updateHSPrice();
    } else if (isHSCancelled) {
      refreshHSPrices();
    }
  }, [hsPrices, isHSInEditMode]);

  useEffect(() => {
    if (isMSInEditMode) {
      const allValidEntries = msPrices.every(isValid);
      if (allValidEntries) setMSPricesValidation(false);
      else setMSPricesValidation(true);
      const lastEntry = msPrices.length
        ? msPrices[msPrices.length - 1]
        : {
            occupancyMax: null,
          };
      if (
        allValidEntries &&
        lastEntry.occupancyMax < 100 &&
        lastEntry.occupancyMax > 0
      ) {
        setMSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
            occupancyMin: lastEntry.occupancyMax + 1,
          },
        ]);
      } else if (lastEntry.occupancyMax === null) {
        setMSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
          },
        ]);
      }
    } else if (isMSSaved) {
      updateMSPrice();
    } else if (isMSCancelled) {
      refreshMSPrices();
    }
  }, [msPrices, isMSInEditMode]);

  useEffect(() => {
    if (isLSInEditMode) {
      const allValidEntries = lsPrices.every(isValid);
      if (allValidEntries) setLSPricesValidation(false);
      else setLSPricesValidation(true);
      const lastEntry = lsPrices.length
        ? lsPrices[lsPrices.length - 1]
        : {
            occupancyMax: null,
          };
      if (
        allValidEntries &&
        lastEntry.occupancyMax < 100 &&
        lastEntry.occupancyMax > 0
      ) {
        setLSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
            occupancyMin: lastEntry.occupancyMax + 1,
          },
        ]);
      } else if (lastEntry.occupancyMax === null) {
        setLSPrices((prevState) => [
          ...prevState,
          {
            ...EMPTY_ROW,
          },
        ]);
      }
    } else if (isLSSaved) {
      updateLSPrice();
    } else if (isLSCancelled) {
      refreshLSPrices();
    }
  }, [lsPrices, isLSInEditMode]);

  useEffect(() => {
    if (copyFromHotelId === null && !ExtremelyHighPrices) return;
    if (!openSelectbar) refreshEHSPrices(copyFromHotelId);
  }, [ExtremelyHighPrices]);

  useEffect(() => {
    if (copyFromHotelId === null && !HighPrices) return;
    if (!openSelectbar) refreshHSPrices(copyFromHotelId);
  }, [HighPrices]);

  useEffect(() => {
    if (copyFromHotelId === null && !MediumPrices) return;
    if (!openSelectbar) refreshMSPrices(copyFromHotelId);
  }, [MediumPrices]);

  useEffect(() => {
    if (copyFromHotelId === null && !LowPrices) return;
    if (!openSelectbar) refreshLSPrices(copyFromHotelId);
  }, [LowPrices]);

  async function updateEHSPrice() {
    const validEHSRows = maxLimit(ehsPrices);
    const validEHSPrices = validEHSRows
      .map((row, index) => {
        if (index === validEHSRows.length - 1) {
          const {occupancyMax} = row;
          return !occupancyMax
            ? {
                ...row,
                occupancyMax: -1,
              }
            : row;
        }
        return row;
      })
      .filter(isValid);

    const sortedEHSPrices = validEHSPrices.sort(
      (a, b) => a.occupancyMin - b.occupancyMin
    );

    const {post} = await authFetch({
      path: `/hotel/${hotelId}/pricing-setup/extremely_high/all`,
    });
    const {error, response, data} = await post(validEHSPrices);
    if (!response?.ok) {
      setnetworkMsg(
        data?.message || "Can't Update Extremely High Price Setup"
      );
      setOpen(true);
    }
    setIsEHSSaved(false);
    refreshEHSPrices();
  }

  async function updateHSPrice() {
    const validHSRows = maxLimit(hsPrices);
    const validHSPrices = validHSRows
      .map((row, index) => {
        if (index === validHSRows.length - 1) {
          const {occupancyMax} = row;
          return !occupancyMax
            ? {
                ...row,
                occupancyMax: -1,
              }
            : row;
        }
        return row;
      })
      .filter(isValid);

    const sortedHSPrices = validHSPrices.sort(
      (a, b) => a.occupancyMin - b.occupancyMin
    );

    const {post} = await authFetch({
      path: `/hotel/${hotelId}/pricing-setup/high/all`,
    });
    const {error, response, data} = await post(validHSPrices);
    if (!response?.ok) {
      setnetworkMsg(data?.message || "Can't Update High Price Setup");
      setOpen(true);
    }
    setIsHSSaved(false);
    refreshHSPrices();
  }

  async function updateMSPrice() {
    const validMSRows = maxLimit(msPrices);
    const validMSPrices = validMSRows
      .map((row, index) => {
        if (index === validMSRows.length - 1) {
          const {occupancyMax} = row;
          return !occupancyMax
            ? {
                ...row,
                occupancyMax: -1,
              }
            : row;
        }
        return row;
      })
      .filter(isValid);

    const sortedMSPrices = validMSPrices.sort(
      (a, b) => a.occupancyMin - b.occupancyMin
    );

    const {post} = await authFetch({
      path: `/hotel/${hotelId}/pricing-setup/medium/all`,
    });
    const {error, response, data} = await post(validMSPrices);
    if (!response?.ok) {
      setnetworkMsg(data?.message || "Can't Update Medium Price Setup");
      setOpen(true);
    }
    setIsMSSaved(false);
    refreshMSPrices();
  }

  async function updateLSPrice() {
    const validLSRows = maxLimit(lsPrices);
    const validLSPrices = validLSRows
      .map((row, index) => {
        if (index === validLSRows.length - 1) {
          const {occupancyMax} = row;
          return !occupancyMax
            ? {
                ...row,
                occupancyMax: -1,
              }
            : row;
        }
        return row;
      })
      .filter(isValid);

    const sortedLSPrices = validLSPrices.sort(
      (a, b) => a.occupancyMin - b.occupancyMin
    );
    const {post} = await authFetch({
      path: `/hotel/${hotelId}/pricing-setup/low/all`,
    });
    const {error, response, data} = await post(validLSPrices);
    
    if (!response?.ok) {
      setnetworkMsg(data?.message || "Can't Update Low Price Setup");
      setOpen(true);
    }

    setIsLSSaved(false);
    refreshLSPrices();
  }

  async function refreshEHSPrices(anotherHotelId = false) {
    const hotelIdToUse = anotherHotelId ? anotherHotelId : hotelId;
    setehsLoading(true);
    const {get} = await authFetch({
      path: `/hotel/${hotelIdToUse}/pricing-setup/extremely_high/all`,
    });
    const {data, error} = await get();
    if (data) {
      setEHSPrices(data.sort((a, b) => a.occupancyMin - b.occupancyMin));
      setError(false);
    }

    if (error) {
      setError(true);
      console.log(error);
    }
    setIsEHSCancelled(false);

    if (anotherHotelId) {
      setIsEHSInEditMode(true);
    }
    setehsLoading(false);
  }

  async function refreshHSPrices(anotherHotelId = false) {
    const hotelIdToUse = anotherHotelId ? anotherHotelId : hotelId;
    sethsLoading(true);
    const {get} = await authFetch({
      path: `/hotel/${hotelIdToUse}/pricing-setup/high/all`,
    });
    const {data, error} = await get();
    if (data) {
      setHSPrices(data.sort((a, b) => a.occupancyMin - b.occupancyMin));
      setError(false);
    }

    if (error) {
      setError(true);
      console.log(error);
    }
    setIsHSCancelled(false);
    if (anotherHotelId) {
      setIsHSInEditMode(true);
    }
    sethsLoading(false);
  }

  async function refreshMSPrices(anotherHotelId = false) {
    const hotelIdToUse = anotherHotelId ? anotherHotelId : hotelId;
    setmsLoading(true);
    const {get} = await authFetch({
      path: `/hotel/${hotelIdToUse}/pricing-setup/medium/all`,
    });
    const {data, error} = await get();
    if (data) {
      setMSPrices(data.sort((a, b) => a.occupancyMin - b.occupancyMin));
      setError(false);
    }

    if (error) {
      setError(true);
      console.log(error);
    }
    setIsMSCancelled(false);
    if (anotherHotelId) {
      setIsMSInEditMode(true);
    }
    setmsLoading(false);
  }

  async function refreshLSPrices(anotherHotelId = false) {
    const hotelIdToUse = anotherHotelId ? anotherHotelId : hotelId;
    setlsLoading(true);
    const {get} = await authFetch({
      path: `/hotel/${hotelIdToUse}/pricing-setup/low/all`,
    });
    const {data, error} = await get();
    if (data) {
      setLSPrices(data.sort((a, b) => a.occupancyMin - b.occupancyMin));
      setError(false);
    }

    if (error) {
      setError(true);
      console.log(error);
    }
    setIsLSCancelled(false);

    if (anotherHotelId) {
      setIsLSInEditMode(true);
    }
    setlsLoading(false);
  }

  function maxLimit(prices) {
    let validRows = prices;
    prices.map((row, idx) => {
      const {occupancyMax} = row;
      if (!occupancyMax) validRows = prices.slice(0, idx + 1);
    });
    return validRows;
  }

  function isValid(price) {
    return (
      price.occupancyMin !== null &&
      price.occupancyMax !== null &&
      price.basePriceMW !== null &&
      price.basePriceWE !== null &&
      price.occupancyMin !== "" &&
      price.occupancyMax !== "" &&
      price.basePriceMW !== "" &&
      price.basePriceWE !== "" &&
      (price.occupancyMax >= price.occupancyMin || price.occupancyMax === -1)
    );
  }

  function onEHSPriceChange(index, key, value) {
    setEHSPrices((prevState) => {
      return prevState.map((price, idx) =>
        idx === index
          ? {
              ...price,
              [key]: value,
            }
          : price
      );
    });
  }

  function onHSPriceChange(index, key, value) {
    setHSPrices((prevState) => {
      return prevState.map((price, idx) =>
        idx === index
          ? {
              ...price,
              [key]: value,
            }
          : price
      );
    });
  }

  function onMSPriceChange(index, key, value) {
    setMSPrices((prevState) => {
      return prevState.map((price, idx) =>
        idx === index
          ? {
              ...price,
              [key]: value,
            }
          : price
      );
    });
  }

  function onLSPriceChange(index, key, value) {
    setLSPrices((prevState) => {
      return prevState.map((price, idx) =>
        idx === index
          ? {
              ...price,
              [key]: value,
            }
          : price
      );
    });
  }

  function toggleEHSEdit() {
    setIsEHSInEditMode(!isEHSInEditMode);
  }

  function toggleHSEdit() {
    setIsHSInEditMode(!isHSInEditMode);
  }

  function toggleMSEdit() {
    setIsMSInEditMode(!isMSInEditMode);
  }

  function toggleLSEdit() {
    setIsLSInEditMode(!isLSInEditMode);
  }

  function handleCloseStatus() {
    setOpen(false);
  }

  const ehonRemoveRowHandler = (index) => {
    setEHSPrices((prevState) => {
      return prevState.filter((_, idx) => idx !== index);
    });
  };

  const ehonAddRowHandler = (index) => {
    setEHSPrices([
      ...ehsPrices.filter((_, idx) => idx <= index),
      {
        occupancyMin: "",
        occupancyMax: "",
        basePriceMW: "",
        basePriceWE: "",
      },
      ...ehsPrices.filter((_, idx) => idx > index),
    ]);
  };

  const honRemoveRowHandler = (index) => {
    setHSPrices((prevState) => {
      return prevState.filter((_, idx) => idx !== index);
    });
  };

  const honAddRowHandler = (index) => {
    setHSPrices([
      ...hsPrices.filter((_, idx) => idx <= index),
      {
        occupancyMin: "",
        occupancyMax: "",
        basePriceMW: "",
        basePriceWE: "",
      },
      ...hsPrices.filter((_, idx) => idx > index),
    ]);
  };

  const monRemoveRowHandler = (index) => {
    setMSPrices((prevState) => {
      return prevState.filter((_, idx) => idx !== index);
    });
  };

  const monAddRowHandler = (index) => {
    setMSPrices([
      ...msPrices.filter((_, idx) => idx <= index),
      {
        occupancyMin: "",
        occupancyMax: "",
        basePriceMW: "",
        basePriceWE: "",
      },
      ...msPrices.filter((_, idx) => idx > index),
    ]);
  };

  const lonRemoveRowHandler = (index) => {
    setLSPrices((prevState) => {
      return prevState.filter((_, idx) => idx !== index);
    });
  };

  const lonAddRowHandler = (index) => {
    setLSPrices([
      ...lsPrices.filter((_, idx) => idx <= index),
      {
        occupancyMin: "",
        occupancyMax: "",
        basePriceMW: "",
        basePriceWE: "",
      },
      ...lsPrices.filter((_, idx) => idx > index),
    ]);
  };

  return {
    extremelyHigh: {
      prices: ehsPrices,
      isInEditMode: isEHSInEditMode,
      setIsInEditMode: setIsEHSInEditMode,
      isCancelled: isEHSCancelled,
      setIsCancelled: setIsEHSCancelled,
      isSaved: isEHSSaved,
      setIsSaved: setIsEHSSaved,
      onPriceChange: onEHSPriceChange,
      addRow: ehonAddRowHandler,
      removeRow: ehonRemoveRowHandler,
      loading: ehsLoading,
      checkPricesValidation: checkEHSPricesValidation,
    },
    high: {
      prices: hsPrices,
      isInEditMode: isHSInEditMode,
      setIsInEditMode: setIsHSInEditMode,
      isCancelled: isHSCancelled,
      setIsCancelled: setIsHSCancelled,
      isSaved: isHSSaved,
      setIsSaved: setIsHSSaved,
      onPriceChange: onHSPriceChange,
      addRow: honAddRowHandler,
      removeRow: honRemoveRowHandler,
      loading: hsLoading,
      checkPricesValidation: checkHSPricesValidation,
    },
    medium: {
      prices: msPrices,
      isInEditMode: isMSInEditMode,
      setIsInEditMode: setIsMSInEditMode,
      isCancelled: isMSCancelled,
      setIsCancelled: setIsMSCancelled,
      isSaved: isMSSaved,
      setIsSaved: setIsMSSaved,
      onPriceChange: onMSPriceChange,
      addRow: monAddRowHandler,
      removeRow: monRemoveRowHandler,
      loading: msLoading,
      checkPricesValidation: checkMSPricesValidation,
    },
    low: {
      prices: lsPrices,
      isInEditMode: isLSInEditMode,
      setIsInEditMode: setIsLSInEditMode,
      isCancelled: isLSCancelled,
      setIsCancelled: setIsLSCancelled,
      isSaved: isLSSaved,
      setIsSaved: setIsLSSaved,
      onPriceChange: onLSPriceChange,
      addRow: lonAddRowHandler,
      removeRow: lonRemoveRowHandler,
      loading: lsLoading,
      checkPricesValidation: checkLSPricesValidation,
    },
    SeasonPricingError: Error,
    pOpen: open,
    errorMsg,
    setErrorMsg,
    pHandleCloseStatus: handleCloseStatus,
    pNetworkMsg: networkMsg,
  };
}
